var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu",on:{"click":_vm.openMenu}},[_c('i',{staticClass:"el-icon-menu"})])
}
var staticRenderFns = []

export { render, staticRenderFns }